export default "__VITE_ASSET__B97dwl7q__"